import { render, staticRenderFns } from "./WellsForm.vue?vue&type=template&id=72d180ac&scoped=true&"
import script from "./WellsForm.vue?vue&type=script&lang=js&"
export * from "./WellsForm.vue?vue&type=script&lang=js&"
import style0 from "./WellsForm.vue?vue&type=style&index=0&id=72d180ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d180ac",
  null
  
)

export default component.exports